export default "__VITE_ASSET__Cw2kEV7n__"